import React from 'react';
import {Link} from 'react-router-dom';
import Banner from 'ui/Banner/Banner';
import Raw from 'ui/Raw/Raw';

const Team = ({count, teamId, title}) => {
    const hasOpenings = count > 0 ? true : false;
    let openingsMessage = 'No Openings';
    if (hasOpenings) {
        openingsMessage = count > 1 ? `${count} Openings` : `${count} Opening`;
    }

    return (
        <dl className="text-center">
            <dt>
                {hasOpenings ? (
                    <Link
                        to={`careers/openings?category=${teamId}`}
                        dangerouslySetInnerHTML={{__html: title}}
                    />
                ) : (
                    <span className="text-muted">{title}</span>
                )}
            </dt>
            <dd>
                <small>{openingsMessage}</small>
            </dd>
        </dl>
    );
};

const Teams = ({
    bgImageUrl,
    title,
    body,
    callToActionText,
    callToActionUrl,
    subTitle,
    teams,
    id,
}) => (
    <section id={id} className="careers-teams">
        <Banner image={bgImageUrl}>
            <h2 className="text-white">{title}</h2>
            <Raw content={body} className="text-constrained" />
        </Banner>
        <div className="container container--overlap text-center">
            <h3>{subTitle}</h3>
            <div className="careers-columns">
                {teams.map((team) => (
                    <Team {...team} key={team.title} />
                ))}
            </div>
            <Link to={callToActionUrl} className="btn btn-default">
                {callToActionText}
            </Link>
        </div>
    </section>
);

export default Teams;
